import Footer from "./Footer";
import Navigation from "./Navigation";
import { motion } from "framer-motion";

export default function PrivacyPage() {
  return (
    <div className="min-h-screen bg-background" style={{ fontFamily: "'Roboto', sans-serif" }}>
      <Navigation />

      <section className="relative min-h-[90vh] flex items-center overflow-hidden bg-[#040814] text-white py-24">

        {/* BACKGROUND */}
        <div className="absolute inset-0">
        </div>

        <div className="relative container mx-auto px-6">

          {/* HEADING */}
          <motion.div
            className="max-w-4xl mx-auto text-center mb-10"
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.7, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <motion.h1
              className="text-4xl md:text-5xl font-extrabold leading-tight"
              initial={{ textShadow: "0px 0px 0px rgba(0,255,255,0)" }}
              animate={{ textShadow: "0px 0px 24px rgba(0,255,255,.4)" }}
              transition={{ duration: 1.2, repeat: Infinity, repeatType: "reverse" }}
            >
              Privacy Policy
            </motion.h1>

            <p className="mt-4 text-base md:text-lg text-gray-300">
              Your privacy matters. We designed this page to clearly explain how your data is protected — simple, transparent, and secure.
            </p>
          </motion.div>

          {/* CARD */}
          <motion.div
            className="max-w-5xl mx-auto"
            initial={{ opacity: 0, y: 50, scale: 0.97 }}
            whileInView={{ opacity: 1, y: 0, scale: 1 }}
            transition={{ duration: 0.8, ease: "easeOut" }}
            viewport={{ once: true }}
          >
            <div className="relative rounded-2xl border border-white/10 bg-white/5 backdrop-blur-xl shadow-2xl p-6 md:p-10 transition-all duration-300 hover:shadow-blue-500/20 hover:border-white/20 hover:-translate-y-1">

              <div className="space-y-6 text-gray-200 text-sm md:text-base leading-relaxed">

                {/* INTRO */}
                <p>
                  Variable Soft privacy is extremely important to us. To better protect you,
                  we provide this notice explaining our online information practices and the
                  choices you can make about the way your information is collected and used.
                  To make this notice easy to find, we make it available on every page of this website.
                </p>

                {/* SECTION 1 */}
                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6 }}
                  viewport={{ once: true }}
                >
                  <h4 className="text-xl font-semibold mb-2 text-white">
                    Information We Collect
                  </h4>

                  <p className="mb-3">
                    This notice applies to all information collected or submitted on the Variable Soft
                    website. On some pages, the types of personal information collected include,
                    but are not limited to:
                  </p>

                  <ul className="list-disc pl-5 space-y-1 text-gray-300">
                    <li className="transition-all hover:translate-x-1">First / Last Name</li>
                    <li className="transition-all hover:translate-x-1">Company Name</li>
                    <li className="transition-all hover:translate-x-1">Email Address</li>
                    <li className="transition-all hover:translate-x-1">Account Password</li>
                    <li className="transition-all hover:translate-x-1">
                      PC, Server Licensing Information and general device information
                    </li>
                    <li className="transition-all hover:translate-x-1">IP Address</li>
                  </ul>
                </motion.div>

                {/* SECTION 2 */}
                <motion.div
                  initial={{ opacity: 0, y: 30 }}
                  whileInView={{ opacity: 1, y: 0 }}
                  transition={{ duration: 0.6, delay: 0.15 }}
                  viewport={{ once: true }}
                >
                  <h4 className="text-xl font-semibold mb-2 text-white">
                    How We Use Personal Information
                  </h4>

                  <p>
                    We use the information you provide about yourself when placing an order only
                    to complete that order and to provide fantastic customer service during the
                    term of your service. We do not share this information with outside parties
                    without your permission.
                  </p>

                  <p>
                    Variable Soft owns the technology, licensing and databases that are deployed
                    to you, or are part of the support agreement — however, you will always retain
                    all rights to your data. We do not use your content to compete with you,
                    advertise to your clients, or contact your clients for any other reason.
                  </p>

                  <p>
                    Finally, we never use or share personally identifiable information in ways
                    unrelated to the ones described above without also providing you an opportunity
                    to opt-out, except under the following circumstances:
                  </p>

                  <ul className="list-disc pl-5 space-y-1">
                    <li className="transition-all hover:translate-x-1">
                      If it becomes necessary to investigate, prevent, or take action regarding
                      illegal activities, suspected fraud, threats to physical safety,
                      violations of Terms of Service, or as otherwise required by law.
                    </li>
                    <li className="transition-all hover:translate-x-1">
                      If ROW Support or Variable Soft is acquired or merged with another company.
                      In this event, you will be notified before information is transferred and
                      becomes subject to a different privacy policy.
                    </li>
                  </ul>
                </motion.div>

              </div>
            </div>
          </motion.div>

        </div>
      </section>

      <Footer />
    </div>
  );
}
